import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wallet } from "lucide-react";
import api, { fmtIDR } from "../lib/api";
import { useI18n } from "../lib/i18n";

export function useBalance() {
  const [balance, setBalance] = useState(null);
  useEffect(() => {
    const load = () => api.get("/balance").then((r) => setBalance(r.data.balance_idr)).catch(() => {});
    load();
    const timer = setInterval(load, 30000);
    return () => clearInterval(timer);
  }, []);
  return balance;
}

export default function HeaderBalance({ mobile = false }) {
  const { t } = useI18n();
  const balance = useBalance();
  if (!balance) return null;
  if (mobile) {
    return (
      <Link to="/account" data-testid="header-balance-mobile"
        className="sm:hidden flex items-center justify-center gap-1.5 border-t border-[#D4AF37]/30 bg-[#D4AF37]/10 text-[#D4AF37] text-xs font-bold py-1.5">
        <Wallet size={14} /> {t("balance.title")}: {fmtIDR(balance)}
      </Link>
    );
  }
  return (
    <Link to="/account" data-testid="header-balance" title={t("balance.title")}
      className="hidden sm:flex items-center gap-1.5 bg-[#D4AF37]/10 border border-[#D4AF37]/60 text-[#D4AF37] hover:bg-[#D4AF37]/20 transition-colors rounded-sm px-2 py-1.5 text-xs font-bold whitespace-nowrap">
      <Wallet size={14} /><span>{t("balance.title")}:</span> {fmtIDR(balance)}
    </Link>
  );
}

export function RefundBanner({ o }) {
  const { t } = useI18n();
  const balance = useBalance();
  if (!(o.refund_idr > 0)) return null;
  return (
    <div data-testid="order-refund-banner" className="bg-[#35C78A]/10 border border-[#35C78A] rounded-lg p-5 mb-6 flex gap-3">
      <Wallet className="text-[#35C78A] shrink-0" size={22} />
      <div>
        <div className="text-[#35C78A] font-bold">{t("order.refund_title").replace("{amount}", fmtIDR(o.refund_idr))}</div>
        <div className="text-sm text-[#F5F3ED] mt-1">{t("order.refund_body")}</div>
        {balance !== null && <div data-testid="order-refund-balance" className="text-sm text-[#D4AF37] font-bold mt-2">{t("balance.title")}: {fmtIDR(balance)}</div>}
      </div>
    </div>
  );
}
